import MicButton from './MicButton';

const inputClass = 'w-full px-3 py-2 border border-gray-200 dark:border-slate-600 rounded-md text-sm bg-white dark:bg-slate-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/10 disabled:opacity-50';

export default function Input({ label, error, className = '', mic, onChange, value, ...props }) {
  function handleTranscript(text) {
    const current = value || '';
    const newValue = current ? current + ' ' + text : text;
    if (onChange) onChange({ target: { value: newValue, name: props.name } });
  }

  return (
    <div className={className}>
      {label && <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">{label}</label>}
      <div className={mic ? 'flex items-center gap-1.5' : ''}>
        <input className={inputClass} value={value} onChange={onChange} {...props} />
        {mic && <MicButton onTranscript={handleTranscript} size={14} />}
      </div>
      {error && <p className="mt-1 text-xs text-error">{error}</p>}
    </div>
  );
}

export function Textarea({ label, error, className = '', mic, onChange, value, ...props }) {
  function handleTranscript(text) {
    const current = value || '';
    const newValue = current ? current + ' ' + text : text;
    if (onChange) onChange({ target: { value: newValue, name: props.name } });
  }

  return (
    <div className={className}>
      {label && <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">{label}</label>}
      <div className="relative">
        <textarea className={inputClass} value={value} onChange={onChange} {...props} />
        {mic && (
          <div className="absolute bottom-2 right-2">
            <MicButton onTranscript={handleTranscript} size={14} />
          </div>
        )}
      </div>
      {error && <p className="mt-1 text-xs text-error">{error}</p>}
    </div>
  );
}
